// extracted by mini-css-extract-plugin
export default {"cls1":"Ge_u8a5qM0Zd7so7VMUg","cls2":"vAPckuBEL69dxhUFkWuV Ge_u8a5qM0Zd7so7VMUg"};